import TAX from "./tax";
import TAX_ID from "./taxId";
import CUSTOMER from "./customer";
import PRE_POST from "./prePost";
import AUTHORIZATION from "./authorization";
import PAYMENT from "./payment";
import BRANDING from "./branding";
import ANALYTICS from "./analytics";
import BILLING from "./billing";
import TESTING from "./testing";
import AUTOMATION from "./automation";

import { UID } from "./common";

export default {
  // title: "Feature comparison",
  header: [
    {
      uid: UID.STRIPE,
      title: "Stripe",
      actions: [
        {
          copy: "Buy now",
          href: "",
          query: {},
          action_uid: "stripe_checkout"
        }
      ]
    },
    {
      uid: UID.PRICEBLOCS,
      title: "PriceBlocs",
      actions: [
        {
          copy: "Buy now",
          href: "",
          query: {},
          action_uid: "stripe_checkout"
        }
      ]
    }
  ],
  groups: [
    TAX,
    TAX_ID,
    CUSTOMER,
    PRE_POST,
    AUTHORIZATION,
    PAYMENT,
    BRANDING,
    ANALYTICS,
    BILLING,
    AUTOMATION,
    TESTING
  ]
};
